import { EquipmentFormValue } from '../types';

export function prepareCreateUpdateEquipmentDTO(formData: EquipmentFormValue) {
  const { commonInfo, attachments, year, make, model, modelBase } = formData;

  return {
    make,
    model,
    modelBase,
    year,
    attachments,
    mileage: commonInfo.mileage,
    hours: commonInfo.hours,
    stockId: commonInfo.stockId,
    classType: commonInfo.class,
    quantity: commonInfo.quantity,
    truckClass: parseInt(commonInfo.class?.replace(/\D/g, '') ?? '', 10) ?? null,
    newUsed: commonInfo.condition,
    wholesaleCost: commonInfo.saleCost,
    retailPrice: commonInfo.retailPrice,
    serialNumberVin: commonInfo?.vin?.trim(),
    totalWholesaleCost: commonInfo.wholeSaleCost,
    additionalDescription: commonInfo.description,
    inventoryItem: {
      status: commonInfo.inventoryItem.status,
    },
  };
}
